// translation-service.ts
import i18next from 'i18next';

export const getTranslation = (key: string, namespace = 'general') => {
    return i18next.t(key, { ns: namespace });
};